<script>

    import { toast } from 'bulma-toast'
    import { UserStore, WalletStore } from '../stores'

    import WalletsService from '../$services/wallets.service'
    import NumeralMethods from '../$methods/numeral.methods'

    let loading = false

    getWalletUser()

    async function getWalletUser() {

        loading = true
        const resp = await WalletsService.getWalletUser($UserStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
            
        WalletStore.set(resp.data)
    }

</script>

{#if !loading}
    { NumeralMethods.cash($WalletStore.amount) }
{/if}